//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/TaggedObject.js";
import "../no/Assemblies.js";
let d=[[[0,"Arrangement",0,"Assemblies.ArrangementsBuilder",0],[0,"IncludeSubOrdinateDesignElements",1,0],[0,"Scope",1,0],[0,"TopLevelAssembly",1,0]],[[["member","selectSubassemblies"],"AddMember",{},2,0],[["member","removeSubassemblies"],"RemoveMember",{},2,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Annotations.PartsListContentsBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.PartsListContentsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.PartsListContentsBuilder.ScopeType = Object.freeze({
    "AllLevels" : "AllLevels", "TopLevelOnly" : "TopLevelOnly", "LeavesOnly" : "LeavesOnly"});

SPLM.Annotations.PartsListContentsBuilder.TopLevelAssemblyType = Object.freeze({
    "ChildPart" : "ChildPart", "SubChildPart" : "SubChildPart"});

export default SPLM;